import HttpError from './HttpError';

export default class AtsApplicationsAlreadyImportedError extends HttpError {}
